import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment'

@Injectable({
  providedIn: 'root'
})
export class UpdateServicesService {
    constructor(private http: HttpClient, private router: Router) { }


/*(Requirement title*,Image , description*)
*/
createServices($data: any) {
    return this.http.post(checkUrl()+"/ecademic/services/add",$data)
    .pipe((response)=>{
        return response;
    })
}

// (Requirement title ,Image , description)
updateServices($data:any){
    return this.http.post(checkUrl()+"/ecademic/services/edit",$data)
    .pipe((response)=>{
          return response;
    })
}

// Requirment ( Id *)
deleteServices($data:any){
    return this.http.post(checkUrl()+"/ecademic/services/delete",$data)
    .pipe((response)=>{
          return response;
    })
}

}
